module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-up-gray-dark-0d62af095f5185b6c666170ecb2ddb2f.svg";